/**
 * components/ConfirmModal.js
 * Small reusable confirm dialog (Batal / confirm). Esc + click-outside close. `message` may be a
 * string or a node. Optional `requireText`: when a non-empty string, shows a type-to-confirm input and
 * disables confirm until the typed value matches (case-insensitive, trimmed) — mirroring
 * DeleteConfirmModal. When absent, the confirm button is always enabled (no input).
 */
import React, { useState } from "react";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function ConfirmModal({ title, message, confirmLabel = "Hapus", danger = true, requireText, onConfirm, onClose }) {
  const [text, setText] = useState("");
  useModalEsc(onClose);

  const gated = typeof requireText === "string" && requireText.trim().length > 0;
  const ok = !gated || text.trim().toLowerCase() === requireText.trim().toLowerCase();

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="modal-title">{title}</h2>
        {message && <p className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>{message}</p>}
        {gated && (
          <div className="form-row">
            <label className="form-label" htmlFor="confirm-modal-gate-text">Ketik <b>{requireText}</b> untuk konfirmasi</label>
            <input id="confirm-modal-gate-text" className="form-input" value={text} autoFocus
              placeholder={requireText} onChange={(e) => setText(e.target.value)} />
          </div>
        )}
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Batal</button>
          <button type="button" className={danger ? "btn btn-danger" : "btn btn-primary"}
            disabled={!ok} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
